import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  AppConfigsList: lazyNamed(() => import('./pages/AppConfigsList/index.tsx'), 'AppConfigsList'),
  AppConfigDetails: lazyNamed(() => import('./pages/AppConfigDetails/index.tsx'), 'AppConfigDetails'),
  AdConfigForm: lazyNamed(() => import('./pages/AdConfigForm/index.tsx'), 'AdConfigForm'),
  AppConfigForm: lazyNamed(() => import('./pages/AppConfigForm/index.tsx'), 'AppConfigForm'),
  ThirdPartyWebsitesList: lazyNamed(() => import('./pages/ThirdPartyWebsitesList/index.tsx'), 'ThirdPartyWebsitesList'),
  ThirdPartyTagForm: lazyNamed(() => import('./pages/ThirdPartyTagForm/index.tsx'), 'ThirdPartyTagForm'),
};
